<script setup lang="ts">
import {ref} from 'vue';

const selectedColor = ref('#00c1e2');

const nums = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
</script>

<template>
	<main>
		<section class="flex" :style="`--bs-primary: ${selectedColor}`">
			<article class="grow">
				<div>color-mix srgb = scss mix()</div>

				<div
					v-for="num in nums.toReversed()"
					:style="`background: color-mix(in srgb, var(--bs-primary), white ${num * 10}%)`"
				>
					&nbsp;
				</div>
				<div
					v-for="num in nums.slice(1)"
					:style="`background: color-mix(in srgb, var(--bs-primary), black ${num * 10}%)`"
				>
					&nbsp;
				</div>
			</article>

			<article class="grow">
				<div>color-mix oklch</div>

				<div
					v-for="num in nums.toReversed()"
					:style="`background: color-mix(in oklch, var(--bs-primary), white ${num * 10}%)`"
				>
					&nbsp;
				</div>

				<div
					v-for="num in nums.slice(1)"
					:style="`background: color-mix(in oklch, var(--bs-primary), black ${num * 10}%)`"
				>
					&nbsp;
				</div>
			</article>

			<article class="grow">
				<div>RCS oklch with chroma reduction</div>

				<div
					v-for="num in nums.toReversed()"
					:style="`background: oklch(from var(--bs-primary) calc(l + (1 - l) * ${num / 10}) calc(c * (1 - ${num / 10})) h);`"
				>
					&nbsp;
				</div>

				<div
					v-for="num in nums.slice(1)"
					:style="`background: oklch(from var(--bs-primary) calc(l * ${1 - num / 10}) calc(c * ${1 - num / 10}) h)`"
				>
					&nbsp;
				</div>
			</article>

			<article class="grow">
				<div>RCS oklch</div>

				<div
					v-for="num in nums.toReversed()"
					:style="`background: oklch(from var(--bs-primary) calc(l + (1 - l) * ${num / 10}) c h);`"
				>
					&nbsp;
				</div>

				<div
					v-for="num in nums.slice(1)"
					:style="`background: oklch(from var(--bs-primary) calc(l * ${1 - num / 10}) c h) `"
				>
					&nbsp;
				</div>
			</article>
		</section>

		<input type="color" v-model="selectedColor" />
	</main>
</template>
